import { AssignmentResponse, AssignmentStatus } from '@/types';

export const isInterviewCompleted = (assignment: AssignmentResponse) => {
  const completedStatuses: AssignmentStatus[] = [
    'interview_completed',
    'transcript_ready',
    'draft_generated',
    'under_review',
    'approved',
    'published',
  ];
  return completedStatuses.includes(assignment.status);
};
